import React, { Component, Fragment, useEffect, useState } from 'react';

import Header from '@common/Header';
import Button from '@common/Button';
import PageLayout from '@common/PageLayout';
import CommonPage from '@common/CommonPage';
import CommonForm from '@common/CommonForm2';
import Constants from '@data/Constants';
import Actions from '@data/Actions';
import './index.css';
import Store from '@data/Store';
const action = new Actions();
const { language_type } = Store;

const index = (props) => {
  const { language } = props;
  const [data, setData] = useState(null);
  const [values, setValues] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isRelated, setRelated] = useState(false);
  const [joins, setJoins] = useState([]);

  const loadTag = (id) => {
    Store.spinner = true;
    action
      .execute(
        'get',
        `${Constants.APIEndpoints.NOTIFICATION}/tag/${id}`
      )
      .then((res) => {
        Store.spinner = false;
        
        if( res.data.data[0].joins && res.data.data[0].joins.length > 0 ) {
          res.data.data[0].has_joins = true;
          setJoins(res.data.data[0].joins);
        }

        setData(res.data.data[0]);
      })
      .catch((error) => {
        console.log(error);
        let messageError = language.ERROR_REQUEST;
        Store.spinner = false;
        Store.toggleAlert(true, messageError, 'error');
      });
  };

  useEffect(() => {
    if (props.value?.id) {
      loadTag(props.value.id);
    }
  }, [props.value]);

  const onChangeField = (field, value, selected, handle, fields, values) => {
    setData({ ...data, [field.name]: value });
  };
  
  const saveJoin = (cond) => {
    if (!joins.includes(cond)) { 
      setJoins(prevJoins => [...prevJoins, cond]);
    } else {
      Store.toggleAlert(true, language.CONDITION_ALREADY_INCLUDED, 'error');
    }
  };

  const handleConditionDeleteJoin = (itemToDelete) => {
    const updatedConditionsList = joins.filter(
      (item) => item !== itemToDelete
    );
    setJoins(updatedConditionsList);
  };

  const saveTag = (obj) => {
    console.log('obj1', obj);

    if( obj.is_related_value === false ) {
      obj.related_table = null;
      obj.related_key = null;
      obj.related_field = null;
      obj.joins = null;
    } else {
      obj.joins = joins;
    }

    let requestType = 'post';
    if (props.value?.id) {
      requestType = 'put';
    }
    Store.spinner = true;
    action
      .execute(requestType, `${Constants.APIEndpoints.NOTIFICATION}/tag`, '', obj).then(
      (res) => {
        Store.spinner = false;
        Store.toggleAlert(true, language.ALERT_INSERT_SUCCESS, 'success');
        props.loadTags();
        props.onClose();
      },
      (error) => {
        console.log(error);
        let messageError = language.ERROR_REQUEST;
        Store.spinner = false;
        Store.toggleAlert(true, messageError, 'error');
      },
    );
  };

  return (
    <CommonPage showMenuIconButton={false} iconAlert={true} loading={false}>
      <CommonForm
        values={data}
        fields={[
          {
            col: 6,
            name: 'name',
            label: language.NAME,
            type: 'text',
            required: true,
            disabled: !!props.value?.id
          },
          {
            col: 6,
            name: 'value',
            label: language.VALUE,
            type: 'text',
            required: true,
            disabled: !!props.value?.id
          },
          {
            col: 4,
            name: 'description',
            label: language.DESCRIPTION,
            type: 'text',
            required: true
          },
          {
            col: 4,
            name: 'es_description',
            label: language.DESCRIPTION + ' (ES)',
            type: 'text',
            required: true
          },
          {
            col: 4,
            name: 'en_description',
            label: language.DESCRIPTION + ' (EN)',
            type: 'text',
            required: true
          },
          {
            col: 12,
            name: 'is_related_value',
            label: language.RELATIONSHIP,
            type: 'switch'
          },
          {
            col: 4,
            name: 'related_table',
            label: language.TABLE,
            type: 'text',
            required: (data && data['is_related_value'] === true) ? true : false,
            visible: (data && data['is_related_value'] === true) ? true : false
          },
          {
            col: 4,
            name: 'related_key',
            label: language.KEY,
            type: 'text',
            required: (data && data['is_related_value'] === true) ? true : false,
            visible: (data && data['is_related_value'] === true) ? true : false
          },
          {
            col: 4,
            name: 'related_field',
            label: language.FIELD,
            type: 'text',
            required: (data && data['is_related_value'] === true) ? true : false,
            visible: (data && data['is_related_value'] === true) ? true : false
          },
          {
            col: 12,
            name: 'has_joins',
            label: 'Joins',
            type: 'switch',
            visible: (data && data['is_related_value'] === true) ? true : false
          },
          {
            col: 12,
            type: 'element',
            visible: (data && data['has_joins'] === true) ? true : false,
            content: (v, h, submit) => (
              <div style={{ marginTop: '16px' }}>
                <CommonForm
                  values={[]}
                  fields={[
                    {
                      col: 6,
                      name: 'join_table_name',
                      label: language.TABLE,
                      type: 'text'
                    },
                    {
                      col: 6,
                      name: 'join_condition',
                      label: language.CONDITION,
                      type: 'text'
                    }
                  ]}
                  onChangeField={onChangeField}
                  hiddenSubmit={false}
                  button={{
                    icon: 'fas fa-plus',
                    label: language.ADD
                  }}
                  onSubmit={(v) => {
                    saveJoin(v);
                  }}
                />
                {joins.length > 0 && (
                  <div>
                    <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
                      JOINS
                    </div>

                    <div
                      className="slaRule"
                      style={{
                        marginTop: '16px',
                        marginBottom: '8px',
                      }}
                    >
                      {joins.map((r, i) => (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            borderBottom:
                              i + 1 !== joins.length
                                ? '1px solid #fff'
                                : 'none',
                            width: '100%',
                            alignItems: 'center',
                            background: '',
                            padding:
                              i + 1 !== joins.length
                                ? '1px 1px 8px'
                                : '1px 1px 0px',
                            marginBottom:
                              i + 1 !== joins.length ? '8px' : '0px',
                          }}
                        >
                          <div style={{ width: '100%', display: 'flex' }}>
                            <span style={{ width: '98%' }}>
                              <div>
                                <strong>{language.TABLE}{': '}</strong>{r.join_table_name}<br />
                                <strong>{language.CONDITION}{': '}</strong>{r.join_condition}
                              </div>
                            </span>

                            <span style={{ width: '2%' }}>
                              <Button
                                variant="circle"
                                icon="fas fa-trash-alt"
                                color="danger"
                                label={language.DELETE}
                                onClick={() => handleConditionDeleteJoin(r)}
                              />{' '}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ),
          }
        ]}
        onChangeField={onChangeField}
        onSubmit={(v) => saveTag(v)}
      />
    </CommonPage>
  );
};

export default index;
